import React, { useState, Fragment } from 'react';
import {
    Avatar, Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Chip,
    Grid,
    List,
    ListItem,
    ListItemText,
    Typography
} from "@material-ui/core";
import AllInclusiveIcon from "@material-ui/icons/AllInclusive";
import FlareIcon from "@material-ui/icons/Flare";
import AttributeTypeCard from "./AttributeTypeCard";
import CapacityCard from "./CapacityCard";
import EvaluatorCard from "./EvaluatorCard";
import LeadSourceCard from "./LeadSourceCard";
import ScheduleCard from "./ScheduleCard";
import ScheduleInStatesCard from "./ScheduleInStatesCard";
import FilterListModal from "./FilterListModal";
import {Alert} from "@material-ui/lab";
import _ from 'lodash';

const RenderCard = ({
    data,
    filterList,
    cardClasses,
    open,
    handleOpen,
    handleClose,
    classes,
    page,
    setPage,
    filterLoading,
    skipVal,
    setSkipVal,
    limit,
    modalData,
    handleSubmit
}) => {
    const {configKey, name, type, attributeType, description, hierarchyLevel, schedules, scheduleInStates} = data;
    const [expanded, setExpanded] = useState(false);

    const handleExpand = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false)
    };

    const setAvatar = (type) => {
        if (typeof type !== 'string') {
            return (
                <Avatar aria-label="type" className={cardClasses.contact}>
                    {type()}
                </Avatar>
            );
        }

        return (
            <Avatar aria-label="type"
                    className={type === 'INCLUDE' ? cardClasses.inclusive : cardClasses.exclusive}>
                {type === 'INCLUDE' ? (<AllInclusiveIcon/>) : (<FlareIcon/>)}
            </Avatar>
        );
    }

    const setSubheader = (type, hierarchyLevel) => {
        return (
            <>
                <Typography>
                    {type === 'INCLUDE' ? 'Inclusive' : 'Exclusive'}
                </Typography>
                {hierarchyLevel ? <ChipLevel hierarchyLevel={hierarchyLevel} /> : null}
            </>
        );
    };

    const ChipLevel = ({hierarchyLevel}) => (
        <div className={classes.chips}>
            <Chip
                label={`Level: ${hierarchyLevel}`}
            />
        </div>
    );

    /**
     * Campaign Card
     */
    const isMinHeight = ['RECENCY_STATIC', 'RECENCY_DYNAMIC', 'HOME_STATE', 'ZIP_CODE', 'Configs'];
    const specialCards = ['SCHEDULE_IN_STATE', 'SCHEDULE', 'LEAD_SOURCE', 'EMAIL', 'CAPACITY', 'SELF_EMPLOYED', 'CAR_LOAN'];

    let configKeyArr = {};
    let headerKeys = [];
    if (attributeType === 'LEAD_SOURCE') {
        configKeyArr = _.mapValues(_.groupBy(description, 'configKey'));
        headerKeys = Object.keys(configKeyArr);
        headerKeys = headerKeys.filter((value) => value !== 'null')
    }

    return (
        <Grid item xs={12} sm={6} md={4} lg={3}>
            <Card component={Card} className={cardClasses.card}>
                <div>
                    <CardHeader
                        avatar={setAvatar(type, hierarchyLevel)}
                        title={attributeType}
                        subheader={setSubheader(type, hierarchyLevel)}
                    />
                    <CardContent className={isMinHeight.includes(attributeType) ? cardClasses.minHeight : ''}>
                        {filterList ? <Typography variant="overline">{filterList.field}</Typography> : null}
                        {!specialCards.includes(attributeType) ? (
                            <>
                                {name ? (
                                    <Typography variant="body2" paragraph>{name}</Typography>
                                ) : (
                                    <>
                                        <AttributeTypeCard description={description} attributeType={attributeType} cardType={type}/>
                                    </>
                                )}
                            </>
                        ) : null}
                        {Object.keys(configKeyArr).length ? (
                            <Fragment>
                                <Typography variant="body2">
                                   <strong>Config Keys:</strong>
                                </Typography>
                                <List>
                                    {headerKeys.map(item => (
                                        <ListItem key={item} style={{ padding: 0 }}>
                                            <ListItemText>
                                                <Box
                                                    display="flex"
                                                    alignItems="flexStart"
                                                    flexDirection="row"
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        style={{paddingRight: '5px'}}
                                                    >
                                                        <strong>{item}: </strong>
                                                    </Typography>
                                                    <Box
                                                        display="flex"
                                                        alignItems="center"
                                                        flexDirection="column"
                                                        css={{
                                                            justifyContent: 'space-between'
                                                        }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            style={{paddingBottom: '5px'}}
                                                        >
                                                            {configKeyArr[item].length}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </ListItemText>
                                        </ListItem>
                                    ))}
                                </List>
                            </Fragment>
                        ) : null}
                        {configKey && attributeType !== 'LEAD_SOURCE' ? (
                                <Typography variant="body2" paragraph>
                                    <strong>Config Key:</strong> {configKey}
                                </Typography>
                        ) : null}
                        {attributeType === 'CAPACITY' ? (
                            <CapacityCard description={description} />
                        ) : null}
                        {attributeType === 'EMAIL' || attributeType === 'SELF_EMPLOYED' || attributeType === 'CAR_LOAN' ? (
                            <EvaluatorCard
                                attributeType={attributeType}
                                cardClasses={cardClasses}
                                expanded={expanded}
                                handleExpand={handleExpand}
                                description={description}
                            />
                        ) : null}
                        {attributeType === 'LEAD_SOURCE' && data.sources && data.sources.type === type ? (
                            <LeadSourceCard
                                classes={classes}
                                data={data}
                                cardClasses={cardClasses}
                            />
                        ) : null}
                        {schedules ? (
                            <ScheduleCard
                                schedules={schedules}
                                cardClasses={cardClasses}
                                expanded={expanded}
                                handleExpand={handleExpand}
                            />
                        ) : null}
                        {scheduleInStates ? (
                            <ScheduleInStatesCard
                                scheduleInStates={scheduleInStates}
                                cardClasses={cardClasses}
                                expanded={expanded}
                                handleExpand={handleExpand}
                            />
                        ) : null}
                    </CardContent>
                </div>
                {attributeType === 'FILTER_LIST' ? filterList && filterList.filterListValues.length ? (
                    <>
                        <CardActions>
                            <Button
                                variant="contained"
                                disableElevation
                                onClick={() => handleOpen(filterList.id)}
                            >
                                View List
                            </Button>
                        </CardActions>
                        <FilterListModal
                            open={open}
                            handleClose={handleClose}
                            modalData={modalData}
                            filterList={filterList}
                            data={data}
                            cardClasses={cardClasses}
                            classes={classes}
                            handleSubmit={handleSubmit}
                            page={page}
                            setPage={setPage}
                            filterLoading={filterLoading}
                            skipVal={skipVal}
                            setSkipVal={setSkipVal}
                            limit={limit}
                        />
                    </>
                ) : (
                    <Alert severity="error">Filter list not found!</Alert>
                ) : null}
            </Card>
        </Grid>
    );
};

export default RenderCard;
